import React, { useCallback } from 'react';
import { Modal } from '@vectord/components';
import { useDispatch, useSelector, batch } from 'react-redux';

import {
  EDIT_PAUSE_DURATION_MODAL_STAGES,
  editPauseDurationModalStageSelector,
  resetUpdateDuration,
  setEditDurationModalStage,
} from 'features/courseResume';
import EditDurationModalStageRenderer from '../EditDurationModalStageRenderer';

function EditDurationModal() {
  const dispatch = useDispatch();
  const modalStage = useSelector(editPauseDurationModalStageSelector);
  const isModalOpen = modalStage !== EDIT_PAUSE_DURATION_MODAL_STAGES.notOpen;

  const handleClose = useCallback(() => {
    batch(() => {
      dispatch(
        setEditDurationModalStage(EDIT_PAUSE_DURATION_MODAL_STAGES.notOpen)
      );
      dispatch(resetUpdateDuration(null));
    });
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      unMountOnClose
      onClose={handleClose}
      size="large"
      withoutHeader
    >
      <EditDurationModalStageRenderer />
    </Modal>
  );
}

export default EditDurationModal;
